export default {
      id: "cancel-usage",
      viewBox: "0 0 512.001 512.001",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#cancel",
      toString: function () {
        return this.url;
      }
    }